<template>
  <div class="app-gallery-grid" :class="[loading ? 'sm-loading': '']">
    <AppGalleryGridLoader v-if="loading"/>
    <template v-else>
      <div class="app-gallery-grid__title" v-html="title"></div>
      <div class="app-gallery-grid__items" v-if="items.length">
        <div class="app-gallery-grid__item" v-for="(item, idx) in items" :key="idx"
             @click="onItemChoice(item.id, item.code)">
          <div class="app-card-gallery">
            <div class="app-card-gallery__image">
              <div class="app-card-gallery__image-wrap" v-if="item.picture">
                <img :src="item.picture.src" :alt="item.picture.description">
              </div>
            </div>
            <div class="app-card-gallery__name" v-html="item.name"></div>
          </div>
        </div>
      </div>
      <div class="app-gallery-grid__backward" @click="onReturn"
           v-show="currentLvl > 0">{{ backwardText }}</div>
    </template>
  </div>
</template>

<script>

import _get from 'lodash.get';
import AppGalleryGridLoader from '@/components/app-gallery-grid-loader/app-gallery-grid-loader.vue';

export default {
  /* eslint-disable */
  name: 'AppGalleryGrid',
  components: {AppGalleryGridLoader},
  props: {
    lang: String,
    year: [Number, String],
  },
  data() {
    return {
      loading: false,
      idObj: {
        prev: null,
        current: null,
      },
      currentLvl: 0,
      items: [],
      title: '',
      backwardText: this.lang === 'ru' ? 'Вернуться обратно' : 'Go back',
    };
  },
  methods: {
    onReturn() {
      if (!this.idObj.prev) {
        this.getItems();
      } else {
        this.getItems(this.idObj.prev);
        this.idObj.current = this.idObj.prev;
        this.idObj.prev = null;
      }
    },
    onItemChoice(id, code) {
      if (code) {
        this.currentLvl++;
        if (!this.idObj.current) {
          this.idObj.current = id;
        } else {
          this.idObj.prev = this.idObj.current;
          this.idObj.current = id;
        }
        this.getItems(id);
      } else {
        this.$emit('eventChoice', id);
      }
    },
    async getItems(id) {
      this.loading = true;
      this.items = [];
      if (!id) {
        this.currentLvl = 0;
        this.idObj.prev = null;
        this.idObj.current = null;
      }
      let res;
      const config = {
        params: {
          lang: this.lang,
          section: id || this.year,
        },
      };
      res = await this.$api.get('api/gallery/get', config);
      if (res) {
        const sections = _get(res, 'data.data.records.sections', null);
        const elements = _get(res, 'data.data.records.elements', null);
        this.items = [...sections, ...elements];
        const nav = _get(res, 'data.data.records.nav', null);
        if (nav.length) {
          let title = '';
          nav.forEach(item => {
            title = title + ' ' + item.name;
          });
          this.title = title;
        }
        this.loading = false;
      }
    },
  },

  async mounted() {
    await this.getItems();
  },

  watch: {
    year() {
      this.getItems();
    },
  },
};

</script>

<style lang="scss">
@import "app-gallery-grid";
</style>
